import React from 'react';

import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';

import PrateceGradevine from '@/models/groblja/pratece_gradevine';
import MapCentricPage from '@/ui/MapCentric/MapCentricPage';

const RegistarPratecihGradevinaMapCentricPage = () => (
    <AppPage titlett="groblja:titles.reg_pratecih_gradevina" needPermission={[Permissions.GrobljaManageOsnovniRegistri]}>
      <MapCentricPage
        model={PrateceGradevine}
        titleToken="groblja:titles.reg_pratecih_gradevina"
        view="default"
        baseRecordPath=""
        mapId={46}
        mapModel={PrateceGradevine}
        allowMinimapHideObjects
        allowExport
      />
    </AppPage>
  );

export default RegistarPratecihGradevinaMapCentricPage;
